export default __webpack_public_path__ + "static/media/80.32aa4cf3.svg";